import React from "react";
const LocalStorageContext = React.createContext(null);
LocalStorageContext.displayName = "LocalStorageContext";
export default LocalStorageContext;
